import cls from "./BlogCode.module.css";

interface BlogCodeProps {
    code: string;
}

export const BlogCode = ({ code }: BlogCodeProps) => {
    return (
        <pre className={cls.pre}>
            <code>{code}</code>
        </pre>
    );
};
